import { useState } from 'react';
import { Alert, Button, Space } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import type { Announcement } from '../types';

interface AnnouncementBannerProps {
  announcements: Announcement[];
  onDismiss: (id: number) => void;
}

export function AnnouncementBanner({ announcements, onDismiss }: AnnouncementBannerProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (announcements.length === 0) return null;

  const getAlertType = (type: Announcement['type']): 'info' | 'warning' | 'success' | 'error' => {
    return type;
  };

  if (announcements.length === 1) {
    const announcement = announcements[0];
    return (
      <Alert
        message={announcement.title}
        description={announcement.message}
        type={getAlertType(announcement.type)}
        showIcon
        closable
        onClose={() => onDismiss(announcement.id)}
        style={{ marginBottom: 16, borderRadius: 8 }}
      />
    );
  }

  // Multiple announcements - show with navigation
  const announcement = announcements[currentIndex];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : announcements.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < announcements.length - 1 ? prev + 1 : 0));
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Alert
        message={
          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <span>{announcement.title}</span>
            <Space size="small">
              <span style={{ fontSize: 12, color: '#888' }}>
                {currentIndex + 1} / {announcements.length}
              </span>
              <Button
                type="text"
                size="small"
                icon={<LeftOutlined />}
                onClick={handlePrev}
              />
              <Button
                type="text"
                size="small"
                icon={<RightOutlined />}
                onClick={handleNext}
              />
            </Space>
          </Space>
        }
        description={announcement.message}
        type={getAlertType(announcement.type)}
        showIcon
        closable
        onClose={() => {
          onDismiss(announcement.id);
          if (currentIndex >= announcements.length - 1 && currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
          }
        }}
        style={{ borderRadius: 8 }}
      />
    </div>
  );
}
